<app-comment-form-g [item]="item" (handleSubmit)="addComment({form: $event, parentId: null})"></app-comment-form-g>

<app-comment-g
  *ngFor="let comment of rootComments; trackBy: trackByComment"
  [comment]="comment"
  [activeComment]="activeComment"
  [replies]="repliesMap.get(comment.id)"
  (setActiveComment)="setActiveComment($event)"
  (deleteComment)="deleteComment($event)"
  (updateComment)="updateComment($event)"
  (addComment)="addComment($event)"
  [currentUser]="currentUser">
</app-comment-g>


